import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Tender, CsvInvoiceArticle } from '@api/models/tender.model';
import { IndexResponse, ShowResponse } from '@api/models/response.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TendersService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/tenders`;

  constructor() { }

  getTenders(page: number = 1, perPage: number = 10, q?: string): Observable<IndexResponse<Tender>> {
    let url = `${this.apiUrl}?page=${page}&per_page=${perPage}`;

    if (q && q.trim()) {
      url += `&q=${encodeURIComponent(q.trim())}`;
    }

    return this.http.get<IndexResponse<Tender>>(url).pipe(
      map(response => response)
    );
  }

  getTender(id: string): Observable<Tender> {
    return this.http.get<ShowResponse<Tender>>(`${this.apiUrl}/${id}`).pipe(
      map(response => response.data)
    );
  }

  createTender(tender: Tender): Observable<Tender> {
    return this.http.post<ShowResponse<Tender>>(`${this.apiUrl}`, tender).pipe(
      map(response => response.data)
    );
  }

  updateTender(id: string, tender: Tender): Observable<Tender> {
    return this.http.put<ShowResponse<Tender>>(`${this.apiUrl}/${id}`, tender).pipe(
      map(response => response.data)
    );
  }

  deleteTender(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  createCsvInvoiceArticle(article: Omit<CsvInvoiceArticle, 'id'>): Observable<CsvInvoiceArticle> {
    return this.http.post<ShowResponse<CsvInvoiceArticle>>(`${environment.apiUrl}/csv-invoice-articles`, {
      product_name: article.product_name,
      tender_id: article.tender_id,
      product_code: article.product_code,
      unit_type: article.unit_type,
    }).pipe(
      map(response => response.data)
    );
  }

  deleteCsvInvoiceArticle(articleId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/csv-invoice-articles/${articleId}`);
  }
}
